"use client";

import { useEffect, useRef, useState } from "react";

// interfaces
import { ICollectionsMain } from "./ICollectionsMain";

// components
import CollectionsMainBanner from "./components/CollectionsMainBanner";
import CollectionsMainContent from "./components/CollectionsMainContent";
import VideoModal from "@/components/Modals/VideoModal";

// helpers
import { scrollToRef } from "@/hooks/scrollToRef";

// assets
import styles from "@/assets/styles/containers/collections-main.module.scss";

const CollectionsMain = ({ page, pages, collections }: ICollectionsMain) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initLoad, setInitLoad] = useState(true);

  const exploreRef = useRef(null);

  // methods
  const handleScrollToListing = () => {
    scrollToRef(exploreRef);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // effect
  useEffect(() => {
    if (initLoad) {
      setInitLoad(false);

      return;
    }

    if (exploreRef.current) {
      scrollToRef(exploreRef);
    }
  }, [exploreRef?.current]);

  return (
    <section className={styles["locl-collections-main"]} data-testid="locl-collections-main">
      <CollectionsMainBanner handleScrollDown={handleScrollToListing} />
      <CollectionsMainContent
        page={page}
        pages={pages}
        collections={collections}
        openModal={handleOpenModal}
        exploreRef={exploreRef}
      />
      <VideoModal open={isModalOpen} onCancel={handleCloseModal} />
    </section>
  );
};

export default CollectionsMain;
